/**
	* ==================================================
	* In heavy use cases you may wanna use a well tested 
	* library like _lodash or _underscore
	* ==================================================
*/

/**
	* @params Two Objects
	* @returns Boolean. True if both objects are eqaul. Otherwise, false
*/
export function deepEqual(x, y) {
  const ok = Object.keys,
    tx = typeof x,
    ty = typeof y;
  return x && y && tx === "object" && tx === ty
    ? ok(x).length === ok(y).length &&
      ok(x).every(key => deepEqual(x[key], y[key]))
    : x === y;
}

/**
	* @params An array and an object
	* @returns position of the object in the array
*/
export function getObjEqualIndex(arr, obj) {
  let result = null;
  arr.forEach((val, index) => {
    if (deepEqual(val, obj)) {
      result = index;
    }
  });
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js